import ListItem, { ListItemProps } from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { fade, hexToRgb, makeStyles } from '@material-ui/core/styles'
import React from 'react'

import { useAnalytics } from '../../lib/analytics'
import { Actions, Categories } from '../../lib/analytics/events'
import { MenuItem as MenuItemType } from '../../operations.wp/types'
import MenuItemIcon from './MenuItemIcon'

type MenuItem = {
  fullWidth?: boolean
  item?: MenuItemType | null
}

const MenuItem = ({ item, fullWidth = false }: MenuItem) => {
  const useStyles = makeStyles(theme => ({
    listItemRoot: {
      '&:hover, &:focus': {
        color: item?.menuItemIcon?.useIcon
          ? fade(hexToRgb(theme.palette.secondary.main), 0.7)
          : theme.palette.secondary.main,
        paddingLeft: fullWidth ? '1rem' : '1.3rem',
      },
      color: theme.palette.secondary.main,
      display: 'inline-block',
      fontSize: '1.2rem',
      lineHeight: fullWidth ? '0' : '',
      padding: '.5rem 1rem',
      textDecoration: 'none',
      transition: 'all .5s ease',
      width: fullWidth ? 'auto' : '100%',
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
    },
    primary: {
      color: theme.palette.secondary.main,
      fontSize: '1.2rem',
      fontWeight: 400,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
    },
  }))
  const classes = useStyles()
  const { trackEvent } = useAnalytics()

  const handleClick = () => {
    trackEvent({
      action: Actions.MenuItemClick,
      category: Categories.HeaderMenu,
      label: item?.label,
      location: Categories.HeaderMenu,
    })
  }

  function ListItemLink(props: ListItemProps<'a', { button?: true }>) {
    return (
      <ListItem
        button
        classes={{
          root: classes.listItemRoot,
        }}
        component="a"
        {...props}
      />
    )
  }

  if (!item?.url) return null

  return (
    <ListItemLink
      key={item.id}
      button
      href={item.url}
      target={item.target || undefined}
      onClick={handleClick}
    >
      {item.menuItemIcon?.iconLabel ? <MenuItemIcon icon={item.menuItemIcon.iconLabel} /> : null}
      {!item.menuItemIcon?.hideLabel && item.label && (
        <ListItemText classes={{ primary: classes.primary }} primary={item.label} />
      )}
    </ListItemLink>
  )
}

export default MenuItem
